module.exports = __webpack_public_path__ + "img/emptyImgGray.d62d79de.svg";